import './styles/log-component.scss'

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Icon } from 'semantic-ui-react'

export default class LogComponent extends React.Component {
  static propTypes = {
    hold:       PropTypes.bool.isRequired,
    activeHold: PropTypes.bool.isRequired,
    log:        PropTypes.object.isRequired,    
    hasNext:    PropTypes.bool.isRequired,
    selected:   PropTypes.bool.isRequired,
    dimmed:     PropTypes.bool.isRequired,
  }

  state = {
    initted: false,
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ initted: true })
    }, 100)
  }

  render() {
    const { log, hasNext, selected, dimmed, hold, activeHold } = this.props
    const { initted } = this.state

    if (!log) return null

    const failed = log.failed

    const className = classnames('log-component', { initted, selected, dimmed, failed, hold, 'active-hold': activeHold })

    return (
      <div className={className}>
        { log.component }
        { hasNext && <Icon name='arrow right'/> }

        <div className="region-tag">
          { log.region }
        </div>
      </div>
    )
  }
}
